import { render, staticRenderFns } from "./SdsContentComponents.vue?vue&type=template&id=8c90645e&scoped=true&"
import script from "./SdsContentComponents.vue?vue&type=script&lang=js&"
export * from "./SdsContentComponents.vue?vue&type=script&lang=js&"
import style0 from "./SdsContentComponents.vue?vue&type=style&index=0&id=8c90645e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90645e",
  null
  
)

export default component.exports